import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { bindActionCreators } from 'redux';
import { HelmetWrapper, PartnerIcons, SkipNavContent, TYPES } from 'sarsaparilla';
import { addAlert } from '../../actions/alerts';
import { CurrentUserProps } from '../../props/currentUser';
import { OrganizationProps } from '../../props/organization';
import { getCurrentUser } from '../../reducers/currentUser';
import SearchForm from '../SearchForm';

import styles from './LandingPage.scss';

const propTypes = {
  history: TYPES.HISTORY,
  currentUser: CurrentUserProps,
  organizations: PropTypes.arrayOf(OrganizationProps),
  addAlert: PropTypes.func.isRequired
};

export class LandingPage extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {};
  }

  goToSearch = () => {
    this.props.history.push('/search');
  };

  render() {
    const logoClasses = `${styles.logo} agency-grid-logo`;
    return (
      <SkipNavContent>
        <HelmetWrapper title="RIDB Home" />
        <main role="main" id="developer-portal-landing-page" className={styles['landing-page']}>
          <div className={`hero-wrap ${styles['hero-image']}`}>
            <div className="hero-content-wrapper">
              <div className="rec-nested-wrap">
                <div className="hero-content-left">
                  <h2>Welcome to the RIDB</h2>
                  <p>
                    RIDB is a part of the Recreation One Stop (Rec1Stop) project, initiated as a result of a government
                    modernization study conducted in 2004. Rec1Stop provides a user-friendly, web-based resource to
                    citizens, offering a single point of access to information about recreational opportunities
                    nationwide. The web site represents an authoritative source of information and services for millions
                    of visitors to federal lands, historic sites, museums, and other attractions/resources.
                  </p>
                </div>
                <div id="dplp-search-form" className="hero-content-right">
                  <div className={styles['search-form']}>
                    <h3>Recreation Information Database</h3>
                    <p>
                      Search RIDB catalog by state, organization, and activity.
                    </p>
                    <SearchForm onSearch={this.goToSearch} />
                  </div>
                </div>
              </div>
            </div>
            <div className={`${styles['data-partners-container']} agency-grid`}>
              <div className="rec-nested-wrap">
                <div className={logoClasses}>
                  <PartnerIcons.BLM />
                </div>
                <div className={logoClasses}>
                  <PartnerIcons.DOT />
                </div>
                <div className={logoClasses}>
                  <PartnerIcons.NOAA />
                </div>
                <div className={logoClasses}>
                  <PartnerIcons.Smithsonian />
                </div>
                <div className={logoClasses}>
                  <PartnerIcons.ForestService />
                </div>
                <div className={logoClasses}>
                  <PartnerIcons.USACE />
                </div>
                <div className={logoClasses}>
                  <PartnerIcons.FWS />
                </div>
                <div className={logoClasses}>
                  <PartnerIcons.NPS />
                </div>
                <div className={logoClasses}>
                  <PartnerIcons.TRE />
                </div>
                <div className={logoClasses}>
                  <PartnerIcons.TVA />
                </div>
                <div className={logoClasses}>
                  <PartnerIcons.DOI />
                </div>
                <div className={logoClasses}>
                  <PartnerIcons.NationalArchives />
                </div>
              </div>
            </div>
          </div>
          <div className="body-wrap">
            <div className="rec-nested-wrap">
              <div className={`body-section ${styles['body-section']}`}>
                <h2>Introduction</h2>
                <p>
                  Welcome to the <Link to="/docs">Recreation Information Database (RIDB)</Link> Application Programing
                  Interface (API). This API is provided for the purpose of accessing RIDB API endpoints which contain
                  information for federal recreation areas, facilities, campsites, tours, and permits.
                </p>
                <p>
                  Federal agencies provide and are responsible for the quality of data contained in the RIDB. Some data
                  may be missing or incomplete. For example, some latitudes and longitudes may be blank. Please be mindful
                  of this when searching for something in particular or applying proximity (radius) filters.By registering
                  to use the API, you are agreeing to comply with all terms and conditions of the&nbsp;
                  <Link to="/ridb-access-agreement">
                    API Access Agreement
                  </Link>.
                </p>
              </div>
              <div className={`body-section ${styles['body-section']}`}>
                <h2>About the RIDB</h2>
                <p>
                  The Recreation Information Database (RIDB) provides data resources to citizens, offering a single point
                  of access to information about recreational opportunities nationwide. The RIDB represents an
                  authoritative source of information and services for millions of visitors to federal lands, historic
                  sites, museums, and other attractions/resources. This initiative integrates multiple Federal channels
                  and sources about recreation opportunities into a one-stop, searchable database of recreational areas
                  nationwide.
                </p>
              </div>
              <div className={`body-section ${styles['body-section']}`}>
                <h2>Intended Audience</h2>
                <p>
                  This website is intended for the general public. It provides instructions on how to extract data from
                  the RIDB.
                </p>
                <p>
                  The data is provided at no cost in order to encourage wide distribution and regular updates to different
                  publications, databases, and websites, so customers can receive correct information from many different
                  systems. As noted elsewhere on this site, by registering to use the API and/or downloading the RIDB
                  data, you are agreeing to be bound by the terms and conditions of the&nbsp;
                  <Link to="/ridb-access-agreement">RIDB API Access Agreement</Link>.
                </p>
                <p>
                  There is no need to contact us before incorporating the data into your system. In exchange, we encourage
                  you to provide a link to Recreation.gov and acknowledge credit, such as
                  <code>&quot;data source: ridb.recreation.gov&quot;</code>.
                </p>
              </div>
            </div>
          </div>
        </main>
      </SkipNavContent>
    );
  }
}

LandingPage.propTypes = propTypes;

const mapStateToProps = (state) => ({
  currentUser: getCurrentUser(state)
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  addAlert
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
